import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"none"} }

import { onBeforeUnmount, onMounted } from "vue";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    WkWebView: any;
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockBack',
  setup(__props) {

// このコンポーネントは
//  ・Androidの戻るボタン
//  ・iOSのback・forward
// を無効化することができます。
// 特定の条件下で有効化・無効化したい場合はv-ifで制御できます。
onBeforeUnmount(() => {
  document.removeEventListener("backbutton", onBackKeyDown, false);
  if (!window.WkWebView) return;
  window.WkWebView.allowsBackForwardNavigationGestures(true);
});

onMounted(() => {
  document.addEventListener("backbutton", onBackKeyDown, false);
  if (!window.WkWebView) return;
  window.WkWebView.allowsBackForwardNavigationGestures(false);
});

function onBackKeyDown() {
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})